export const COLOR_BLACK = 'rgb(17, 17, 17)';
export const COLOR_WHITE = 'rgb(255, 255, 255)';
export const CUSTOM_CLASS_NAME = 'elfsight-lib-datepicker';
export const LOCALES_ALIASES: Record<string, string> = {
  en: 'en-US'
};
